var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iv2__host-name"},[_c('span',{staticClass:"iv2__host-name--text theme-f__host-name"},[_vm._v(_vm._s(_vm.organization.copy_right))])])}
var staticRenderFns = []

export { render, staticRenderFns }